import { render, staticRenderFns } from "./SearchReserves.vue?vue&type=template&id=83694d82&scoped=true&"
import script from "./SearchReserves.vue?vue&type=script&lang=ts&"
export * from "./SearchReserves.vue?vue&type=script&lang=ts&"
import style0 from "./SearchReserves.vue?vue&type=style&index=0&id=83694d82&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83694d82",
  null
  
)

export default component.exports